import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { resolveTenant } from "@/lib/tenant";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));

resolveTenant().then((state) => {
  if (state === "missing") {
    root.render(
      <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "system-ui, sans-serif", color: "#475569", textAlign: "center", padding: 24 }}>
        <div><h1 style={{ fontSize: 22, color: "#0f172a" }}>This domain isn&apos;t connected to a store yet</h1>
          <p style={{ marginTop: 8 }}>If you own this domain, finish connecting it from your Sell24x7 dashboard.</p></div>
      </div>,
    );
    return;
  }
  root.render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </React.StrictMode>,
  );
});
